import { useEffect, useState } from 'react'
import { FileText, RefreshCw, Download, Upload } from 'lucide-react'

interface MoloniData {
  invoices: number
  totalRevenue: number
  pendingInvoices: number
  recentInvoices: Array<{
    id: string
    number: string
    client: string
    amount: number
    date: string
    status: string
  }>
}

export default function MoloniPage() {
  const [data, setData] = useState<MoloniData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchMoloniData()
  }, [])

  const fetchMoloniData = async () => {
    setLoading(true)
    // TODO: Implementar chamada real à API do Moloni
    setTimeout(() => {
      setData({
        invoices: 0,
        totalRevenue: 0,
        pendingInvoices: 0,
        recentInvoices: []
      })
      setLoading(false)
    }, 1000)
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Moloni</h1>
          <p className="text-gray-600 mt-1">Gestão de faturas e documentos fiscais</p>
        </div>
        <div className="flex gap-2">
          <button className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition">
            <Upload className="w-4 h-4" />
            Enviar
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition">
            <Download className="w-4 h-4" />
            Exportar
          </button>
          <button
            onClick={fetchMoloniData}
            className="flex items-center gap-2 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition"
          >
            <RefreshCw className="w-4 h-4" />
            Atualizar
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total de Faturas</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.invoices || 0}</p>
            </div>
            <FileText className="w-8 h-8 text-green-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Receita Total</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">€{data?.totalRevenue.toFixed(2) || '0.00'}</p>
            </div>
            <FileText className="w-8 h-8 text-blue-500" />
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Faturas Pendentes</p>
              <p className="text-2xl font-bold text-gray-900 mt-2">{data?.pendingInvoices || 0}</p>
            </div>
            <FileText className="w-8 h-8 text-yellow-500" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Faturas Recentes</h2>
        </div>
        <div className="p-6">
          {data?.recentInvoices.length === 0 ? (
            <p className="text-gray-500 text-center py-8">Nenhuma fatura encontrada</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="text-left text-gray-600 border-b">
                    <th className="pb-3">Número</th>
                    <th className="pb-3">Cliente</th>
                    <th className="pb-3">Valor</th>
                    <th className="pb-3">Data</th>
                    <th className="pb-3">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.recentInvoices.map((invoice) => (
                    <tr key={invoice.id} className="border-b">
                      <td className="py-3">{invoice.number}</td>
                      <td className="py-3">{invoice.client}</td>
                      <td className="py-3">€{invoice.amount.toFixed(2)}</td>
                      <td className="py-3">{invoice.date}</td>
                      <td className="py-3">
                        <span className="px-2 py-1 bg-gray-100 text-black rounded text-sm">
                          {invoice.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
